import { useState, useEffect } from 'react';
import ConstantsBasedPullDownMenu from './ConstantsBasedPullDownMenu';
import { listAllDeclarations } from '../../api/declarations';

export const declarationsBaseElement = {
    elementName: "selectedDeclaration",
    textDescription: "Select Declaration",
    pullDownMenu: []
};

const SelectDeclarationInput = ({ onChange, value }) => {
    const [declarations, setDeclarations] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchDeclarations = async () => {
        setLoading(true);

        // List all declarations per logged in user
        try {
            const result = await listAllDeclarations()
            setLoading(false);
            setDeclarations(result.items.map((declaration) => {
                const { description } = declaration.jdeclaration.meta;

                return ({
                    key: declaration.creationTime,
                    value: description
                });
            }));
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchDeclarations();
    }, []);


    return (
        <ConstantsBasedPullDownMenu
            controlled
            onChange={onChange}
            value={value}
            element={{
                ...declarationsBaseElement,
                pullDownMenu: [
                    { "key": "DEFAULT", "value": "Please Select" },
                    ...declarations
                ]
            }}
        />
    )
};

export default SelectDeclarationInput;